module.exports = __webpack_public_path__ + "img/arrow-back-black.948e5744.svg";